export const appConfig = {
  apiBaseUrl: process.env.API_BASE_URL || "",
  useMockApi: process.env.USE_MOCK_API !== "false",
};
